
export enum enumVideoLinkType {
  GoogleCloudStorage = 'GoogleCloudStorage', // image store within GoogleCloudStorage
  ExternalSource = 'ExternalSource', // a video hosted at an external source (YouTube, Vimeo, etc.)
}
